import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, renderSlot as _renderSlot, withModifiers as _withModifiers, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-af44f432"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "service-group" }
const _hoisted_2 = { class: "service-group__section wrapper" }
const _hoisted_3 = { class: "service-group__section wrapper service-group__services" }
const _hoisted_4 = {
  key: 0,
  class: "service-group__alerts"
}
const _hoisted_5 = { class: "wrapper" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = ["onMouseenter", "onMouseleave"]
const _hoisted_8 = {
  key: 1,
  class: "service-group__section--scrollable service-group__related-services"
}

import { useServiceRelatedServicesQuery } from '@/queries/public/services'
import PhotoGallery from '@/components/public/PhotoGallery.vue'
import PublicServiceGroupAvailabilitySearch from '@/components/public/group/PublicServiceGroupAvailabilitySearch.vue'
import { computed, onMounted, ref } from 'vue'
import RelatedServices from '@/components/public/RelatedServices.vue'
import { servicePublicDetailsCommonProps } from '@/enums/public'
import { useFetchPublicGroupedServicesMutation } from '@/queries/service/serviceGroup'
import { PublicServiceGroupRelation } from '@/models/service/serviceGroup.model'
import { useToast } from 'vue-toastification'
import { useI18n } from 'vue-i18n'
import {
  ValidationErrorsForOneObject,
  ValidationErrorsGeneric,
} from '@/models/error.model'
import PublicServiceGroupItem from '@/components/public/group/PublicServiceGroupItem.vue'
import { MultimediaItem } from '@/models/multimedia.model'
import {
  getValidationErrorData,
  scrollFirstErrorIntoView,
} from '@/utils/errors'
import {
  createOrUpdateGroupOrderItem,
  useCreateOrderMutation,
} from '@/queries/cart'
import { useOrderStore } from '@/store/order'
import {
  AnyCreateOrderItemPayload,
  CreateGroupServiceOrderItem,
  GroupAvailability,
  GroupAvailabilityItem,
  GroupedServiceData,
  IGroupAvailabilitySearch,
} from '@/models/public/order.model'
import router from '@/router'
import { ROUTE_PATHS } from '@/router/public/paths'
import { storeToRefs } from 'pinia'
import { ALERT_TYPES, FORMATS, SIZES } from '@/enums/components'
import SubmitButton from '@/components/public/SubmitButton.vue'
import BaseButton from '@/components/BaseButton.vue'
import InfoHelper from '@/components/InfoHelper.vue'
import { Alert } from '@/models/shared.model'


export default /*#__PURE__*/_defineComponent({
  __name: 'PublicServiceGroup',
  props: {
  ...servicePublicDetailsCommonProps,
},
  emits: ['cartUpdated'],
  setup(__props, { emit: emits }) {

const props = __props

const orderStore = useOrderStore()
const { order } = storeToRefs(orderStore)
const i18n = useI18n()
const toast = useToast()




const availabilitySearch = ref<IGroupAvailabilitySearch>({
  start: null,
  end: null,
  group_size: 1,
})
const availability = ref<GroupAvailability | undefined>(undefined)
const groupedServicesData = ref<GroupedServiceData[]>([])
const errors = ref<ValidationErrorsForOneObject | undefined>(undefined)
const isAddToCartLoading = ref<boolean>(false)

const dealWithPayload = (gsIndex, payload) => {
  groupedServicesData.value[gsIndex].payload = payload
}

const groupExistingItemsAmount = computed<number>(() => {
  return groupedServicesData.value.filter((item) => !!item.payload).length
})

const groupedServices = computed<PublicServiceGroupRelation[]>(() => {
  return groupedServicesData.value.map(
    (item: GroupedServiceData) => item.groupedService,
  )
})
const groupedServicePayloads = computed<
  Array<AnyCreateOrderItemPayload | CreateGroupServiceOrderItem | null>
>(() => {
  const resp = groupedServicesData.value.map(
    (item: GroupedServiceData) => item.payload,
  )
  return resp
})

const groupedServiceAvailabilityItems = computed<
  Array<GroupAvailabilityItem | undefined>
>(() => {
  const groupedItemAvailabilities = availability.value?.items ?? []
  return groupedServicesData.value.map((data: GroupedServiceData) => {
    return groupedItemAvailabilities.find(
      (availabilityItem: GroupAvailabilityItem) => {
        return (
          availabilityItem.service.hash_id ===
          data.groupedService.service.hash_id
        )
      },
    )
  })
})

const isAvailable = computed<boolean | undefined>(() => {
  return availability.value?.is_available
})

onMounted(() => {
  fetchGroupedServices()
    .then((data: PublicServiceGroupRelation[]) => {
      groupedServicesData.value = data.map((item) => ({
        groupedService: item,
        payload: null,
      }))
    })
    .catch(() => {
      toast.error(i18n.t('dataLoadError'))
    })
})

const gallery = computed<MultimediaItem[]>(() => {
  return props.service?.gallery ?? []
})

const { data: relatedServices } = useServiceRelatedServicesQuery(
  ref(props.serviceId),
  props.isPreview,
)

const { mutateAsync: fetchGroupedServices } =
  useFetchPublicGroupedServicesMutation(ref(props.serviceId), props.isPreview)

const { mutateAsync: createOrder } = useCreateOrderMutation()

const addGroupToCart = async () => {
  isAddToCartLoading.value = true
  errors.value = undefined
  if (!orderStore.orderUuid) {
    try {
      const data = await createOrder()
      orderStore.updateOrder(data)
    } catch (error: unknown) {
      errors.value = getValidationErrorData(error)
      isAddToCartLoading.value = false
      return
    }
  }
  const payload: CreateGroupServiceOrderItem = {
    group_service: props.service.id,
    items: groupedServicesData.value.map((data) => ({
      related_service: data.groupedService.service.id,
      payload: data.payload
        ? {
            ...data.payload,
            item_group: null,
          }
        : null,
    })),
  }

  errors.value = undefined
  createOrUpdateGroupOrderItem(orderStore.orderUuid, payload)
    .then((response) => {
      orderStore.updateOrder(response.data)
      // we reset selections because we don't want users to accidentally add
      // multiple times nor do we support modifying added group from details.
      // Successful add should reset state and enable to either:
      // * add group again
      // * go to cart
      groupedServicesData.value = groupedServicesData.value.map((data) => {
        return {
          ...data,
          payload: null,
        }
      })
      toast.success(i18n.t('addToCartSuccess'))
      emits('cartUpdated')
    })
    .catch((error) => {
      errors.value = getValidationErrorData(error)
      scrollFirstErrorIntoView({
        additionalQueries: ['.service-group-item--errors'],
      })
    })
    .finally(() => {
      isAddToCartLoading.value = false
    })
}

const getRowErrors = (index: number): ValidationErrorsGeneric | undefined => {
  return errors?.value?.items?.[index]
}

const anySelected = computed<boolean>(() => {
  return groupedServicePayloads.value.some((payload) => payload !== null)
})

const canAddToCart = computed<boolean>(() => {
  if (!anySelected.value) return false
  const maxAmount = props.service?.max_amount
  const minAmount = props.service?.min_amount
  const existingAmount = groupExistingItemsAmount.value
  if (minAmount && existingAmount < minAmount) {
    return false
  }
  if (maxAmount && existingAmount > maxAmount) {
    return false
  }
  return true
})

const alerts = computed<Alert[]>(() => {
  const alertList = []

  const nonFieldErrors = (errors?.value?.non_field_errors ||
    []) as Array<string>
  for (const errorMessage of nonFieldErrors) {
    alertList.push({
      text: errorMessage,
      alertType: ALERT_TYPES.DANGER,
    })
  }

  return alertList
})

return (_ctx: any,_cache: any) => {
  const _component_AlertBanner = _resolveComponent("AlertBanner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_unref(gallery).length)
        ? (_openBlock(), _createBlock(PhotoGallery, {
            key: 0,
            photos: _unref(gallery)
          }, null, 8, ["photos"]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.enableOrdering)
      ? (_openBlock(), _createBlock(PublicServiceGroupAvailabilitySearch, {
          key: 0,
          modelValue: availabilitySearch.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((availabilitySearch).value = $event)),
          service: _ctx.service,
          class: _normalizeClass({
        'service-group-search--sticky': _unref(isAvailable) === undefined,
      }),
          onAvailability: _cache[1] || (_cache[1] = (value) => (availability.value = value))
        }, null, 8, ["modelValue", "service", "class"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(groupedServices), (groupedService, gsIndex) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: groupedService.service.hash_id
        }, [
          (!groupedService.is_service_hidden)
            ? (_openBlock(), _createBlock(PublicServiceGroupItem, {
                key: 0,
                value: groupedService,
                "group-service": _ctx.service.hash_id,
                "is-preview": _ctx.isPreview,
                "enable-ordering": _ctx.enableOrdering && _unref(isAvailable) !== undefined,
                referral: _ctx.referral,
                errors: getRowErrors(gsIndex),
                payload: _unref(groupedServicePayloads)?.[gsIndex] ?? null,
                "availability-search": availabilitySearch.value,
                "availability-item": _unref(groupedServiceAvailabilityItems)[gsIndex],
                "onUpdate:payload": (payload) => dealWithPayload(gsIndex, payload)
              }, null, 8, ["value", "group-service", "is-preview", "enable-ordering", "referral", "errors", "payload", "availability-search", "availability-item", "onUpdate:payload"]))
            : _createCommentVNode("", true)
        ], 64))
      }), 128)),
      (_unref(alerts))
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(alerts), (alert, alertIndex) => {
              return (_openBlock(), _createBlock(_component_AlertBanner, {
                key: alertIndex,
                text: alert.text,
                "alert-type": alert.alertType,
                class: "service-group__alert"
              }, null, 8, ["text", "alert-type"]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["service-group__actions wrapper", {
        'service-group__actions--sticky':
          _unref(orderStore).isOrderWithItems || _unref(canAddToCart),
      }])
    }, [
      (_unref(orderStore).isOrderWithItems && !_ctx.isPreview)
        ? (_openBlock(), _createBlock(SubmitButton, {
            key: 0,
            format: _unref(FORMATS).PRIMARY,
            size: _unref(SIZES).MEDIUM,
            label: _ctx.$t('goToCart'),
            icon: "arrow-right",
            "icon-right": true,
            onClick: _cache[2] || (_cache[2] = _withModifiers(
          () => {
            _unref(router).push({
              name: _unref(ROUTE_PATHS).CART,
              params: { uuid: _unref(order).uuid },
            })
          }
        , ["prevent"]))
          }, null, 8, ["format", "size", "label"]))
        : _createCommentVNode("", true),
      (!_ctx.isPreview && _ctx.enableOrdering)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (!_unref(canAddToCart))
              ? (_openBlock(), _createBlock(InfoHelper, { key: 0 }, {
                  activator: _withCtx(({ toggle }) => [
                    _createElementVNode("div", {
                      class: "info-helper__wrapper",
                      onMouseenter: toggle,
                      onMouseleave: toggle
                    }, [
                      _createVNode(BaseButton, {
                        format: _unref(FORMATS).PRIMARY,
                        size: _unref(SIZES).MEDIUM,
                        label: _ctx.$t('addToCart'),
                        loading: isAddToCartLoading.value,
                        disabled: !_unref(canAddToCart),
                        class: "service-group__action",
                        icon: "shopping-cart",
                        "icon-right": "",
                        onClick: _withModifiers(addGroupToCart, ["prevent"])
                      }, null, 8, ["format", "size", "label", "loading", "disabled", "onClick"])
                    ], 40, _hoisted_7)
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(" " + _toDisplayString(!_unref(anySelected)
              ? _ctx.$t('groupView.info.noneSelected')
              : (_ctx.service.min_amount || 0) ===
                (_ctx.service.max_amount || _unref(groupedServices).length)
              ? _ctx.$t('groupView.info.wrongQuantityEquals', {
                  minAmount: _ctx.service.min_amount || 0,
                })
              : _ctx.$t('groupView.info.wrongQuantity', {
                  minAmount: _ctx.service.min_amount || 0,
                  maxAmount: _ctx.service.max_amount || _unref(groupedServices).length,
                })), 1)
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(BaseButton, {
                  key: 1,
                  format: _unref(FORMATS).PRIMARY,
                  size: _unref(SIZES).MEDIUM,
                  label: _ctx.$t('addToCart'),
                  loading: isAddToCartLoading.value,
                  disabled: !_unref(canAddToCart),
                  class: "service-group__action",
                  icon: "shopping-cart",
                  "icon-right": "",
                  onClick: _withModifiers(addGroupToCart, ["prevent"])
                }, null, 8, ["format", "size", "label", "loading", "disabled", "onClick"]))
          ]))
        : _createCommentVNode("", true)
    ], 2),
    (!props.hideRelated)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          (_unref(relatedServices)?.length)
            ? (_openBlock(), _createBlock(RelatedServices, {
                key: 0,
                title: _ctx.$t('relatedServices.heading'),
                services: _unref(relatedServices),
                "is-preview": _ctx.isPreview,
                referral: {
          referral_type: 's',
          referral_code: props.service.hash_id,
        }
              }, null, 8, ["title", "services", "is-preview", "referral"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})